import { useEffect, useRef, useState } from 'react';

import { SelectListCheck } from 'shared/ui/icon';

export const PeriodSelectModal = ({ period, onSelect, isPeriodOpen, setIsPeriodOpen, options }) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    if (isPeriodOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = originalStyle;

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isPeriodOpen]);

  const modalContainerRef = useRef(null);
  const draggableAreaRef = useRef(null);

  const [dragValue, setDragValue] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const y1 = useRef(0);
  const y2 = useRef(0);

  function handleTouchStart(e) {
    y1.current = e.touches[0].clientY;
    setIsDragging(true);
  }

  function handleTouchMove(e) {
    y2.current = e.touches[0].clientY;
    const MOVE_DISTANCE = y2.current - y1.current;
    y1.current = y2.current;
    setDragValue(dragValue + MOVE_DISTANCE);
  }

  function handleTouchEnd() {
    if (modalContainerRef.current.clientHeight / 3 < dragValue) setIsPeriodOpen(false);
    setDragValue(0);
    setIsDragging(false);
  }
  return (
    <>
      {isPeriodOpen && <div className='lab-result__dim' onClick={() => setIsPeriodOpen(false)} />}
      <div
        className={`lab-result__bottom-sheet ${isPeriodOpen ? 'is-open' : ''}`}
        style={
          isDragging
            ? {
                transform: `translateY(${dragValue < 0 ? 0 : dragValue}px)`,
                transition: 'none',
              }
            : {}
        }
      >
        <div className='lab-result__bottom-sheet-wrap' ref={modalContainerRef}>
          <div
            className='lab-result__sheet-draggable-area'
            ref={draggableAreaRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          />
          <div className='lab-result__sheet-handle' />

          <h3 className='lab-result__sheet-title'>기간 선택</h3>

          <ul className='lab-result__sheet-list'>
            {options.map((item) => (
              <li
                key={item.key}
                className={`lab-result__sheet-item ${period.key === item.key ? 'is-selected' : ''}`}
                onClick={() => {
                  onSelect(item);
                  setIsPeriodOpen(false);
                }}
              >
                {item.label}
                {period.key === item.key && (
                  <span className='check'>
                    <SelectListCheck />
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

